import React from "react";
import { observer } from "mobx-react";
import { AiSearchResponseViewStore } from "../../store";
import { AiSearchResponseViewForm } from "./AiSearchResponseViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type AiSearchResponseViewProps = {
  aiSearchResponseViewStore: AiSearchResponseViewStore;
};

export const AiSearchResponseView: React.FC<AiSearchResponseViewProps> =
  observer(({ aiSearchResponseViewStore }) => {
    return (
      <div>
        <AiSearchResponseViewForm
          conversationValue={aiSearchResponseViewStore.conversationValue}
          query={aiSearchResponseViewStore.queryValue}
          response={aiSearchResponseViewStore.responseValue}
          sources={aiSearchResponseViewStore.sourcesValue}
          explanation={aiSearchResponseViewStore.explanationValue}
          tokenUsage={aiSearchResponseViewStore.tokenUsageValue}
          createdAt={aiSearchResponseViewStore.createdAtValue}
          ratingOptions={aiSearchResponseViewStore.getRatingOptions()}
          rating={aiSearchResponseViewStore.ratingValue}
          evaluatedAt={aiSearchResponseViewStore.evaluatedAtValue}
          evaluatedByValue={aiSearchResponseViewStore.evaluatedByValue}
          toolCallsVisibleColumns={
            aiSearchResponseViewStore.toolCallsVisibleColumns
          }
          toolCallsSetColumnWiths={(x) =>
            aiSearchResponseViewStore.toolCallsSetColumnWiths(x)
          }
          toolCallsRows={aiSearchResponseViewStore.toolCallsRowsDyn}
          onPrint={(handlePrint: () => void) =>
            aiSearchResponseViewStore.printAiSearchResponse(handlePrint)
          }
          onCancel={() => aiSearchResponseViewStore.cancelAiSearchResponse()}
          onEdit={
            aiSearchResponseViewStore.isEditEnabled
              ? () => aiSearchResponseViewStore.editAiSearchResponse()
              : undefined
          }
        />
        <ErrorDialog
          open={aiSearchResponseViewStore.errorDialogOpened}
          title={aiSearchResponseViewStore.errorTitle}
          description={aiSearchResponseViewStore.errorDescription}
          onClose={() => aiSearchResponseViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
